import { DownloadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Layout,
  message,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import ListTable from "../../../common/ListTable";
import moment from "moment";
import { createRef, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { OB_REPORT_PERMISSION } from "routes/permissions";
import {
  BUYER_INQUIRY_LIST_ENDPOINT,
  GET_OB_INQUIRY_LIST,
  GET_OB_STYLE_LIST,
  GET_OB_SUBSTYLE_LIST,
  OB_ADD,
  OB_EDIT,
  OB_EXCEL_REPORT,
  OB_LIST,
  OB_PDF_REPORT,
  OB_SAM_DATA_BANK_LIST,
  OB_STYLE,
  OB_TEMPLATES,
  SUBSTYLE_LIST,
  UPDATE_MANPOWER,
} from "../../../apiServices/API_ENDPOINTS";
import { getData, postData, putData } from "../../../apiServices/common";
import HandleNotification from "../../../common/Notification";
import AppPageHeader from "../../../common/PageHeader";
import {
  cglFormatDate,
  hasPermission,
  isArrayAndHasValue,
} from "../../../utils/functions";
import InventoryLayOutCommon from "../../InventoryFabric/LayOut/InventoryLayOutCommon";
import MachineSummary from "../MachineSummary";
import OBFormView from "../OBShowForm/viewOB";
import OBTable from "../OBTable";
import TargetTable from "../TargetTable";
import ExpectedBreakdown from "./ExpectedBreakdown";
import "./index.css";
import Summary from "./Summary";

const OperationBulletinShow = (props) => {
  // Props
  const { edit, view, manpowerMode } = props;

  // States
  const [obSamBanks, setObSamBanks] = useState(null);
  const [sections, setSections] = useState([]);
  const [obShowData, setObShowData] = useState(null);
  const [obTemplates, setObTemplates] = useState(null);
  const [buyerInquiryList, setBuyerInquiryList] = useState(null);
  const [expectedNoOfWorkers, setExpectedNoOfWorkers] = useState(null);
  const [obInquiryList, setObInquiryList] = useState(null);
  const [obStyleList, setObStyleList] = useState(null);
  const [obSubStyleList, setObSubStyleList] = useState(null);
  const [CmStatus, setCmStatus] = useState(null);
  const [styleList, setStyleList] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalExcel, setIsModalExcel] = useState(false);
  const [targetHour, setTargetHour] = useState("");
  const [subStyleList, setSubStyleList] = useState(null);
  const [isPrint, setIsPrint] = useState(false);
  const [isSectionLoading, setIsSectionLoading] = useState(false);
  const [sectionFetchError, setSectionFetchError] = useState(null);

  // Antd
  const [form] = Form.useForm();
  const [obShowForm] = Form.useForm();
  const { Content } = Layout;
  const { Title } = Typography;
  const { Option } = Select;

  // Router
  const { ob_id } = useParams();
  const navigate = useNavigate();

  // Others
  const exportRef = createRef(null);

  const printFn = useReactToPrint({
    contentRef: exportRef,
    documentTitle: "Operation Bulletin",
    onAfterPrint: () => {
      setIsPrint(false);
    },
  });

  const getStyles = async (filterValues) => {
    if (view) return;
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      page: filterValues?.page || 1,
      ...filterValues,
    };
    const query = `${OB_STYLE}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data);
    }
  };

  const getSubStyles = async (filterValues) => {
    if (view) return;
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      page: filterValues?.page || 1,
      ...filterValues,
    };
    const query = `${SUBSTYLE_LIST}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSubStyleList(response?.data?.data?.data);
    }
  };

  const getAllSections = async (filterValues) => {
    if (view) return;
    const query = `${OB_SAM_DATA_BANK_LIST}`;
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      page: filterValues?.page || 1,
      ...filterValues,
    };
    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      const allOBSAMBanks = response?.data?.data?.data;
      isArrayAndHasValue(allOBSAMBanks) && setObSamBanks(allOBSAMBanks);
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Error getting all sections data!",
        null,
      );
    }
  };

  const setOBTableData = async (id) => {
    const query = `${OB_LIST}/${id}/edit`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const allSections = [...sections];
      const obData = response?.data?.data;
      setObShowData(obData);
      setExpectedNoOfWorkers(obData?.summary?.ob_summary?.no_of_workers);
      setCmStatus(obData?.inquiry_details?.cm_status);

      // Iterate and create sections array
      obData?.operation_bulletine_details?.forEach((obDetail) => {
        // const foundSAM = obDetail?.sam_data_bank;
        const foundSAM = {
          ...obDetail?.sam_data_bank,
          updated_sam: obDetail?.updated_sam,
          manual_worker_helper_sam:
            obDetail?.sam_data_bank?.manual_worker_helper_sam ||
            obDetail?.sam_data_bank?.worker_helper_sam ||
            null,
          manual_worker_iron_sam:
            obDetail?.sam_data_bank?.manual_worker_iron_sam ||
            obDetail?.sam_data_bank?.worker_iron_sam ||
            null,
          manual_worker_machine_sam:
            obDetail?.sam_data_bank?.manual_worker_machine_sam ||
            obDetail?.sam_data_bank?.worker_machine_sam ||
            null,
          color: obDetail?.color,
        };

        const foundSectionId = foundSAM ? foundSAM?.ob_section_info?.id : null;
        const foundSection = allSections?.find(
          (section) => section?.section_id === foundSectionId,
        );

        if (!foundSection) {
          // Push new data to array
          allSections.push({
            section_id: foundSAM?.ob_section_info?.id,
            section_name: foundSAM?.ob_section_info?.name,
            section_data: [foundSAM],
          });
        } else {
          // Push data to existing array
          const sectionIndex = allSections.findIndex(
            (section) => section?.section_id === foundSAM?.ob_section_info?.id,
          );
          const isExists = allSections[sectionIndex].section_data.some(
            (sam) => sam?.id === foundSAM?.id,
          );

          if (!isExists || manpowerMode) {
            allSections[sectionIndex].section_data.push(foundSAM);
          }
        }
      });

      // Set sections state
      isArrayAndHasValue(allSections) && setSections(allSections);
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Error getting selected ob info!",
        null,
      );
    }
  };

  const getSelectedObInfo = useCallback(
    async (id, no_of_hour, per_hour_target, manpowerMode) => {
      setIsSectionLoading(true);
      setSectionFetchError(null);
      const editQuery = `${OB_LIST}/${id}/edit`;
      let showQuery = `${OB_LIST}/details-data/${id}`;

      if (manpowerMode)
        showQuery = `${OB_LIST}/details-data/${id}?manpowerMode=1`;
      const query = view || manpowerMode ? showQuery : editQuery;

      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const allSections = [...sections];
        const obData = response?.data?.data;

        setObShowData(obData);
        setExpectedNoOfWorkers(obData?.summary?.ob_summary?.no_of_workers);
        setCmStatus(obData?.inquiry_details?.cm_status);

        const inquiryDetailsData = obData?.inquiry_details;
        const styleData = obData?.style;
        const buyerInquiryListCopy = isArrayAndHasValue(buyerInquiryList)
          ? [...buyerInquiryList]
          : [];
        const styleListCopy = isArrayAndHasValue(styleList)
          ? [...styleList]
          : [];
        const subStyleListCopy = isArrayAndHasValue(subStyleList)
          ? [...subStyleList]
          : [];
        const isExistsInquiry = buyerInquiryListCopy.some(
          (item) => item?.id === inquiryDetailsData?.id,
        );
        const isExistsStyle = styleListCopy.some(
          (item) => item?.id === styleData?.id,
        );
        const isExistsSubStyle = subStyleListCopy.some(
          (item) => item?.id === obData?.sub_style_info?.id,
        );

        if (!isExistsInquiry) {
          buyerInquiryListCopy.push(inquiryDetailsData);
          setBuyerInquiryList(buyerInquiryListCopy);
        }

        if (!isExistsStyle) {
          styleListCopy.push(styleData);
          setStyleList(styleListCopy);
        }

        if (!isExistsSubStyle) {
          subStyleListCopy.push(obData?.sub_style_info);
          setSubStyleList(subStyleListCopy);
        }

        // Set form fields data
        form.setFieldsValue({
          style_id: obData?.style?.id,
          buying_office_id: obData?.buying_office?.id,
          buying_office_name: obData?.buying_office?.name,
          buyer_id: obData?.buyer?.id,
          buyer_name: obData?.buyer?.name,
          sales_contract_id: obData?.sales_contract?.id,
          sales_contract_no: obData?.sales_contract?.reference_no,
          entry_date: obData?.entry_date ? moment(obData?.entry_date) : null,
          description: obData?.style?.description,
          inquiry_id: obData?.inquiry_id,
          note: obData?.note,
          sub_style_id: obData?.sub_style_info?.id,
          sub_contract_factory_id: obData?.sub_contract_factory_id,
          factory_name: obData?.factory_info?.name,
          subcontract_status:
            obData?.subcontract_status || obData?.sub_contract_factory_id,
        });

        // Iterate and create sections array
        obData?.operation_bulletine_details?.forEach((obDetail) => {
          // const foundSAM = obDetail?.sam_data_bank;
          const foundSAM = {
            ...obDetail?.sam_data_bank,
            updated_sam: obDetail?.updated_sam,
            manual_worker_helper_sam:
              obDetail?.sam_data_bank?.manual_worker_helper_sam ||
              obDetail?.sam_data_bank?.worker_helper_sam ||
              null,
            manual_worker_iron_sam:
              obDetail?.sam_data_bank?.manual_worker_iron_sam ||
              obDetail?.sam_data_bank?.worker_iron_sam ||
              null,
            manual_worker_machine_sam:
              obDetail?.sam_data_bank?.manual_worker_machine_sam ||
              obDetail?.sam_data_bank?.worker_machine_sam ||
              null,
            color: obDetail?.color,
            ob_detail_id: obDetail?.id,
          };

          const foundSectionId = foundSAM
            ? foundSAM?.ob_section_info?.id
            : null;
          const foundSection = allSections?.find(
            (section) => section?.section_id === foundSectionId,
          );

          if (!foundSection) {
            // Push new data to array
            allSections.push({
              section_id: foundSAM?.ob_section_info?.id,
              section_name: foundSAM?.ob_section_info?.name,
              section_data: [foundSAM],
            });
          } else {
            // Push data to existing array
            const sectionIndex = allSections.findIndex(
              (section) =>
                section?.section_id === foundSAM?.ob_section_info?.id,
            );
            const isExists = allSections[sectionIndex].section_data.some(
              (sam) => sam?.id === foundSAM?.id,
            );

            if (!isExists || manpowerMode) {
              allSections[sectionIndex].section_data.push(foundSAM);
            }
          }
        });

        // Set sections state
        isArrayAndHasValue(allSections) && setSections(allSections);
        setIsSectionLoading(false);
      } else {
        setIsSectionLoading(false);
        setSectionFetchError("Could not load this list.");
        HandleNotification(
          "error",
          "bottomRight",
          "Error getting selected ob info!",
          null,
        );
      }
    },
    [form, sections, view],
  );

  const getAllObTemplates = async (filterValues) => {
    if (view || manpowerMode) return;
    const { selectedTemplate, filterValue } = filterValues || {};
    let filterName = null;
    let endpoint = `${OB_TEMPLATES}`;

    switch (selectedTemplate) {
      case "ob_template":
        filterName = "tamplate_name";
        endpoint = `${OB_TEMPLATES}`;
        break;
      case "inquiry":
        filterName = "inquiry_no";
        endpoint = `${GET_OB_INQUIRY_LIST}`;
        break;
      case "style":
        filterName = "style_no";
        endpoint = `${GET_OB_STYLE_LIST}`;
        break;
      case "substyle":
        filterName = "sub_style_no";
        endpoint = `${GET_OB_SUBSTYLE_LIST}`;
        break;
      default:
        break;
    }

    const query = endpoint;
    const bodyData = {
      ...(filterName ? { [filterName]: filterValue } : {}),
    };

    const response = await getData(query, false, bodyData);
    if (response && response?.data?.code === 200) {
      const masterData = response?.data?.data?.data;
      const templateSamData =
        isArrayAndHasValue(masterData) &&
        masterData?.map((item) => {
          const samData =
            isArrayAndHasValue(item?.ob_tamplet_details) &&
            item?.ob_tamplet_details?.map((sam) => {
              return {
                ...sam?.sam_data_bank,
              };
            });
          return {
            sam_data_bank: samData,
            template_name: item?.tamplate_name,
            id: item?.id,
          };
        });
      templateSamData && setObTemplates(templateSamData);
    } else {
      message.error("Error getting OB Templates");
    }
  };

  const getAllBuyerInquiry = async (filterValues) => {
    if (view) return;
    const bodyData = {
      per_page: 10,
      ...filterValues,
    };
    const query = `${BUYER_INQUIRY_LIST_ENDPOINT}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyerInquiryList(response?.data?.data?.data);
    }
  };

  const getAllOBInquiry = async (filterValues) => {
    if (view || manpowerMode) return;
    const bodyData = {
      per_page: 20,
      ...filterValues,
    };
    const query = `${GET_OB_INQUIRY_LIST}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setObInquiryList(response?.data?.data?.data);
    }
  };

  const getAllOBStyle = async (filterValues) => {
    if (view || manpowerMode) return;
    const bodyData = {
      per_page: 20,
      ...filterValues,
    };
    const query = `${GET_OB_STYLE_LIST}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setObStyleList(response?.data?.data?.data);
    }
  };

  const getAllOBSubStyle = async (filterValues) => {
    if (view || manpowerMode) return;
    const bodyData = {
      per_page: 20,
      ...filterValues,
    };
    const query = `${GET_OB_SUBSTYLE_LIST}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setObSubStyleList(response?.data?.data?.data);
    }
  };

  useEffect(() => {
    // Get all sections data on first load
    getAllSections();
    getAllObTemplates();
    getAllBuyerInquiry();
    // getAllOBInquiry();
    // getAllOBStyle();
    // getAllOBSubStyle();
    getStyles();
    getSubStyles();
  }, []);

  useEffect(() => {
    // Get selected ob info for edit
    if ((ob_id || ob_id === 0) && manpowerMode) {
      getSelectedObInfo(ob_id, null, null, true);
    }
    if ((ob_id || ob_id === 0) && !manpowerMode) {
      getSelectedObInfo(ob_id);
    }
  }, [ob_id, view, manpowerMode]);

  const onSelectSAM = (id) => {
    const allSections = [...sections];
    const foundSAM = obSamBanks?.find((sam) => sam?.id === id);
    const foundSectionId = foundSAM ? foundSAM?.ob_section_info?.id : null;
    const foundSection = sections?.find(
      (section) => section?.section_id === foundSectionId,
    );

    if (!foundSectionId) {
      HandleNotification(
        "error",
        "bottomRight",
        "Error getting section!",
        null,
      );
      return;
    }

    if (!foundSection) {
      // Push new data to array
      allSections.push({
        section_id: foundSAM?.ob_section_info?.id,
        section_name: foundSAM?.ob_section_info?.name,
        section_data: [foundSAM],
      });
    } else {
      // Push data to existing array
      const sectionIndex = allSections.findIndex(
        (section) => section?.section_id === foundSAM?.ob_section_info?.id,
      );
      const isExists = allSections[sectionIndex].section_data.some(
        (sam) => sam?.id === foundSAM?.id,
      );

      if (!isExists) {
        const newItem = {
          ...foundSAM,
          isNewlyAdded: true,
        };

        allSections[sectionIndex].section_data.push(newItem);

        setTimeout(() => {
          const row = document.querySelector(`[data-sam-id="${newItem.id}"]`);
          if (row) {
            row.scrollIntoView({ behavior: "smooth", block: "center" });
          }

          setTimeout(() => {
            const updatedSections = [...sections];
            updatedSections[sectionIndex].section_data = updatedSections[
              sectionIndex
            ].section_data.map((item) => ({ ...item, isNewlyAdded: false }));
            setSections(updatedSections);
          }, 2000);
        }, 500);
      } else {
        // If data section already exists
        HandleNotification(
          "error",
          "bottomRight",
          "Section already selected before!",
          null,
        );
      }
    }

    form.resetFields(["section_id"]);
    isArrayAndHasValue(allSections) && setSections(allSections);
  };

  const removeRow = (id) => {
    // Find existing section data by id in sections array
    // remove if exists
    const allSections = [...sections];
    const filteredSections = allSections.map((section) => {
      const filteredSectionData = section?.section_data.filter(
        (sam) => sam?.id !== id,
      );
      return {
        ...section,
        section_data: filteredSectionData,
      };
    });

    setSections(filteredSections);
  };

  const rowPositionChange = (id, sectionId, destination) => {
    const allSections = structuredClone(sections);
    const selectedSection = allSections.find(
      (sectionItem) => sectionItem?.section_id === sectionId,
    );
    const sectionData = selectedSection?.section_data;

    const activeIndex = sectionData.findIndex((item) => item?.id === id);
    const overIndex = destination === "up" ? activeIndex - 1 : activeIndex + 1;

    // Ensure the indices are within bounds
    if (
      activeIndex < 0 ||
      activeIndex >= sectionData.length ||
      overIndex < 0 ||
      overIndex >= sectionData.length
    ) {
      return;
    }

    // Remove the item from the array
    const [draggedItem] = sectionData.splice(activeIndex, 1);

    // Insert the dragged item at the new position
    sectionData.splice(overIndex, 0, draggedItem);

    // Update the position key in every item
    allSections.forEach((item, index) => {
      item.position = index + 1;
    });

    // Now, dataSource is updated with the new order
    setSections(allSections);
  };

  const onChangeValue = (value, id, name) => {
    // Create a lookup object for quick access to sections and items
    const sectionLookup = {};
    const itemLookup = {};

    sections.forEach((section) => {
      sectionLookup[section.section_id] = section;
      section.section_data.forEach((item) => {
        itemLookup[item.id] = item;
      });
    });

    // Check if the section and item exist
    if (itemLookup[id] && sectionLookup[itemLookup[id].section_id]) {
      // Update the specified field (name parameter) with the new value
      itemLookup[id][name] = value ? value : 0;

      // Update the state with the modified sections array
      setSections([...sections]); // This spread operator is crucial for ensuring state update
    }
  };

  const onChangeSAMValue = (value, id, name) => {
    // Create a lookup object for quick access to sections and items
    const sectionLookup = {};
    const itemLookup = {};

    sections.forEach((section) => {
      sectionLookup[section.section_id] = section;
      section.section_data.forEach((item) => {
        itemLookup[item.id] = item;
      });
    });

    // Check if the section and item exist
    if (itemLookup[id] && sectionLookup[itemLookup[id].section_id]) {
      // Update the specified field (name parameter) with the new value
      itemLookup[id][name] = value ? value : 0;
      itemLookup[id]["updated_sam"] = value ? value : 0;

      // Update the state with the modified sections array
      setSections([...sections]); // This spread operator is crucial for ensuring state update
    }
  };

  const showModal = (select) => {
    if (select === "excel") {
      setIsModalExcel(true);
    } else {
      setIsModalExcel(false);
    }
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    if (!targetHour) {
      message.error("Target hour cannot be empty!");
      return;
    }
    try {
      if (isModalExcel) {
        onDownloadExcel(`?per_hour_target=${targetHour}&button=ok`);
      } else {
        onDownloadPDF(`?per_hour_target=${targetHour}&button=ok`);
      }
    } catch (error) {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }
    setIsModalVisible(false);
  };
  const handleSkip = () => {
    try {
      if (isModalExcel) {
        onDownloadExcel(`?button=skip`);
      } else {
        onDownloadPDF(`?button=skip`);
      }
    } catch (error) {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }

    setIsModalVisible(false);
  };

  const onDownloadExcel = async (queryParams) => {
    const no_of_hour = obShowForm.getFieldValue("no_of_hour");
    const per_hour_target = obShowForm.getFieldValue("per_hour_target");
    const bodyData = {
      id: ob_id,
      no_of_hour: no_of_hour ? Number(no_of_hour) : null,
      per_hour_target: per_hour_target ? Number(per_hour_target) : null,
    };
    const query = `${OB_EXCEL_REPORT}${queryParams}`;

    const response = await getData(
      query,
      false,
      bodyData,
      { "Content-Type": "blob" }, //Custome Header
      "arraybuffer", //Response-Type to get excel file
    );

    if (response && response?.status === 200) {
      const outputFilename = `ob.xlsx`;

      // If you want to download file automatically using link attribute.
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Error getting excel report!",
        null,
      );
    }
  };
  const onDownloadPDF = async (queryParams) => {
    // Replace obShowForm and ob_id with appropriate values
    const no_of_hour = obShowForm.getFieldValue("no_of_hour");
    const per_hour_target = obShowForm.getFieldValue("per_hour_target");
    const bodyData = {
      id: ob_id, // Replace ob_id with the appropriate value
      no_of_hour: no_of_hour ? Number(no_of_hour) : null,
      per_hour_target: per_hour_target ? Number(per_hour_target) : null,
    };
    const query = `${OB_PDF_REPORT}${ob_id}${queryParams}`;
    try {
      const response = await getData(
        query,
        false,
        bodyData,
        { "Content-Type": "application/pdf" }, // Change Content-Type to application/pdf
        "blob", // Change Response-Type to blob
      );
      if (response?.status === 200) {
        const outputFilename = `${Date()}ob.pdf`;

        // If you want to download file automatically using link attribute.
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf",
          }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();
      } else {
        HandleNotification(
          "error",
          "bottomRight",
          "Error getting PDF report!",
          null,
        );
      }
    } catch (error) {
      // Handle any exceptions here
      HandleNotification(
        "error",
        "bottomRight",
        "Error getting PDF report!",
        null,
      );
    }
  };

  useEffect(() => {
    if (isPrint) {
      printFn();
      setIsPrint(false);
    }
  }, [isPrint]);

  const extra = (
    <div className="extra-button-container">
      {!view && (
        <Button
          htmlType="submit"
          type="primary"
          size="small"
          style={{ marginRight: 5 }}
          onClick={() => {
            form.submit();
          }}
          disabled={CmStatus === 1}
        >
          {" "}
          {`Save`}
        </Button>
      )}

      {!view && (
        <Button
          htmlType="submit"
          size="small"
          onClick={() => form.resetFields()}
        >
          {" "}
          Reset
        </Button>
      )}

      {view && (
        <Space>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              setIsPrint(true);
            }}
            disabled={!hasPermission([OB_REPORT_PERMISSION])}
          >
            {hasPermission([OB_REPORT_PERMISSION]) ? "Print" : "No Permission"}
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => showModal("excel")}
            disabled={!hasPermission([OB_REPORT_PERMISSION])}
          >
            {hasPermission([OB_REPORT_PERMISSION])
              ? "Download Excel"
              : "No Permission"}
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => showModal("pdf")}
            disabled={!hasPermission([OB_REPORT_PERMISSION])}
          >
            {hasPermission([OB_REPORT_PERMISSION])
              ? "Download PDF"
              : "No Permission"}
          </Button>
        </Space>
      )}
    </div>
  );

  const onFinish = async (formValues) => {
    // Sam Data Calculate
    const samData = {
      total_smv_machine_sam: 0,
      total_smv_helper_sam: 0,
      total_smv_iron_sam: 0,
      total_target_machine_sam: 0,
      total_target_helper_sam: 0,
      total_target_iron_sam: 0,
      total_sam: 0,
      total_updated_sam: 0,
      total_updated_smv_helper_sam: 0,
      total_updated_smv_iron_sam: 0,
      total_updated_smv_machine_sam: 0,
    };

    sections?.forEach((section) => {
      section?.section_data?.forEach((sectionDataItem) => {
        samData.total_sam += sectionDataItem?.sam;
        samData.total_updated_sam += sectionDataItem?.updated_sam
          ? Number(sectionDataItem?.updated_sam)
          : sectionDataItem?.sam;

        switch (sectionDataItem?.ob_machine_type_info?.name.toLowerCase()) {
          case "helper":
            samData.total_smv_helper_sam += sectionDataItem?.sam;
            samData.total_updated_smv_helper_sam += sectionDataItem?.updated_sam
              ? Number(sectionDataItem?.updated_sam)
              : sectionDataItem?.sam;
            samData.total_target_helper_sam +=
              60 /
              (sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam);
            break;
          case "hp":
            samData.total_smv_helper_sam += sectionDataItem?.sam;
            samData.total_updated_smv_helper_sam += sectionDataItem?.updated_sam
              ? Number(sectionDataItem?.updated_sam)
              : sectionDataItem?.sam;
            samData.total_target_helper_sam +=
              60 /
              (sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam);
            break;
          case "iron":
            samData.total_smv_iron_sam += sectionDataItem?.sam;
            samData.total_updated_smv_iron_sam += sectionDataItem?.updated_sam
              ? Number(sectionDataItem?.updated_sam)
              : sectionDataItem?.sam;
            samData.total_target_iron_sam +=
              60 /
              (sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam);
            break;
          case "ir":
            samData.total_smv_iron_sam += sectionDataItem?.sam;
            samData.total_updated_smv_iron_sam += sectionDataItem?.updated_sam
              ? Number(sectionDataItem?.updated_sam)
              : sectionDataItem?.sam;
            samData.total_target_iron_sam +=
              60 /
              (sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam);
            break;
          default:
            samData.total_smv_machine_sam += sectionDataItem?.sam;
            samData.total_updated_smv_machine_sam +=
              sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam;
            samData.total_target_machine_sam +=
              60 /
              (sectionDataItem?.updated_sam
                ? Number(sectionDataItem?.updated_sam)
                : sectionDataItem?.sam);
            break;
        }
      });
    });

    // Section Values
    const sectionValues = sections?.flatMap((section) => {
      return section?.section_data?.flatMap((sectionDataItem) => {
        return {
          ob_detail_id: sectionDataItem?.ob_detail_id || null,
          sam_data_bank_id: sectionDataItem?.id,
          updated_sam:
            Number(sectionDataItem?.updated_sam) ?? sectionDataItem?.sam,
          target_helper_sam:
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() ===
              "helper" ||
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() === "hp"
              ? Number((60 / sectionDataItem?.sam).toFixed(2))
              : null,
          target_iron_sam:
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() ===
              "iron" ||
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() === "ir"
              ? Number((60 / sectionDataItem?.sam).toFixed(2))
              : null,
          target_machine_sam:
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() !==
              "helper" &&
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() !==
              "hp" &&
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() !==
              "ir" &&
            sectionDataItem?.ob_machine_type_info?.name.toLowerCase() !== "iron"
              ? Number((60 / sectionDataItem?.sam).toFixed(2))
              : null,
          manual_worker_machine_sam:
            sectionDataItem?.manual_worker_machine_sam ?? null,
          manual_worker_helper_sam:
            sectionDataItem?.manual_worker_helper_sam ?? null,
          manual_worker_iron_sam:
            sectionDataItem?.manual_worker_iron_sam ?? null,
          color: sectionDataItem?.color || null,
        };
      });
    });

    const bodyData = {
      style_id: formValues?.style_id ? Number(formValues?.style_id) : null,
      buying_office_id: formValues?.buying_office_id
        ? Number(formValues?.buying_office_id)
        : null,
      buyer_id: formValues?.buyer_id ? Number(formValues?.buyer_id) : null,
      sales_contract_id: formValues?.sales_contract_id
        ? Number(formValues?.sales_contract_id)
        : null,
      entry_date: formValues?.entry_date
        ? moment(formValues?.entry_date).format("YYYY-MM-DD")
        : null,
      total_updated_smv_machine_sam: Number(
        samData.total_updated_smv_machine_sam,
      ).toFixed(2),
      total_updated_smv_helper_sam: Number(
        samData.total_updated_smv_helper_sam,
      ).toFixed(2),
      total_updated_smv_iron_sam: Number(
        samData.total_updated_smv_iron_sam,
      ).toFixed(2),
      total_smv_machine_sam: Number(samData.total_smv_machine_sam).toFixed(2),
      total_smv_helper_sam: Number(samData.total_smv_helper_sam).toFixed(2),
      total_smv_iron_sam: Number(samData.total_smv_iron_sam).toFixed(2),
      total_target_machine_sam: Number(
        samData.total_target_machine_sam.toFixed(2),
      ),
      total_target_helper_sam: Number(
        samData.total_target_helper_sam.toFixed(2),
      ),
      total_target_iron_sam: Number(samData.total_target_iron_sam.toFixed(2)),
      total_sam: samData.total_sam,
      total_updated_sam: samData.total_updated_sam,
      values: sectionValues,
      inquiry_id: formValues?.inquiry_id || null,
      expectedNoOfWorkers: expectedNoOfWorkers,
      note: formValues?.note || null,
      sub_style_id: formValues?.sub_style_id || null,
      sub_contract_factory_id: formValues?.sub_contract_factory_id || null,
      subcontract_status: formValues?.subcontract_status ? 1 : 0,
    };

    // API Call
    let query;
    if (manpowerMode) {
      query = `${UPDATE_MANPOWER}/${ob_id}`;
    } else {
      query = ob_id || ob_id === 0 ? `${OB_EDIT}/${ob_id}` : `${OB_ADD}`;
    }
    let response = null;

    if (ob_id || ob_id === 0) {
      response = await putData(query, bodyData);
    } else {
      response = await postData(query, bodyData);
    }

    if (response && response?.code === 200) {
      HandleNotification(
        "success",
        "bottomRight",
        "Operation bulletin added successfully!",
        null,
      );
      // Navigate to ob list page
      if (!edit && !manpowerMode) {
        window.open(
          `/merchandising/operation-bulletin/update-manpower/${response?.data?.id}`,
        );
      } else {
        navigate(`/merchandising/operation-bulletin`);
      }
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Error adding operation bulletin!",
        null,
      );
    }
  };

  const createDataForOBTemplate = (id) => {
    const foundOb = obTemplates?.find((ob) => ob?.id === id);
    const sam_data_bank = foundOb?.sam_data_bank;
    const allSections = [];

    isArrayAndHasValue(sam_data_bank) &&
      sam_data_bank?.forEach((item) => {
        const sectionExists = allSections?.find(
          (section) => section?.section_id === item?.ob_section_info?.id,
        );

        if (sectionExists) {
          sectionExists?.section_data?.push(item);
        } else {
          allSections.push({
            section_id: item?.ob_section_info?.id,
            section_name: item?.ob_section_info?.name,
            section_data: [item],
          });
        }
      });

    isArrayAndHasValue(allSections) && setSections(allSections);
  };

  const onSelectObTemplate = (id) => {
    const from_value = form.getFieldValue("from_template_name");

    switch (from_value) {
      case "ob_template":
        createDataForOBTemplate(id);
        break;
      case "inquiry":
        setOBTableData(id);
        break;
      case "style":
        setOBTableData(id);
        break;
      case "substyle":
        setOBTableData(id);
        break;
      default:
        break;
    }
  };

  const onSortTableBody = useCallback(
    ({ oldIndex, newIndex, collection }) => {
      const sectionsCopy = [...sections];
      const selectedSectionData = sectionsCopy?.find(
        (section) => section?.section_id === collection,
      )?.section_data;

      // Remove the item from the array
      const [draggedItem] = selectedSectionData.splice(oldIndex, 1);

      // Insert the dragged item at the new position
      selectedSectionData.splice(newIndex, 0, draggedItem);

      // Update the position key in every item
      selectedSectionData.forEach((item, index) => {
        item.position = index + 1;
      });

      // Set modified array to the state
      setSections(sectionsCopy);
    },
    [sections],
  );

  const onSortMainTable = useCallback(
    ({ oldIndex, newIndex, collection }) => {
      const sectionsCopy = [...sections];

      // Remove the item from the array
      const [draggedSection] = sectionsCopy.splice(oldIndex, 1);

      // Insert the dragged item at the new position
      sectionsCopy.splice(newIndex, 0, draggedSection);

      // Update the position key in every item
      sectionsCopy.forEach((item, index) => {
        item.position = index + 1;
      });

      // Set modified array to the state
      setSections(sectionsCopy);
    },
    [sections],
  );

  const clearSections = () => {
    setSections([]);
  };

  const headerStyle = {
    display: "block",
    textAlign: "center",
    fontSize: "16px",
    padding: "0px",
    margin: "0px",
    lineHeight: "1.2",
  };

  let formateSection = sections?.map((section) => {
    return section?.section_data?.map((sectionItem, i) => {
      return {
        ...sectionItem,
        section_name: sectionItem?.name,
        color: sectionItem?.color,
        className: String(section?.section_name)
          .toLowerCase()
          .split(" ")
          .join("-"),
        condition: sectionItem?.condition,
        smv_mc:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "helper" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "iron" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "hp"
            ? sectionItem?.sam
            : "",
        smv_hp:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "helper" ||
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "hp"
            ? sectionItem?.sam
            : "",
        smv_ir:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "iron"
            ? sectionItem?.sam
            : "",
        updated_smv_mc:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "helper" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "iron" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "hp"
            ? sectionItem?.updated_sam ?? sectionItem?.sam
            : "",
        updated_smv_hp:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "helper" ||
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "hp"
            ? sectionItem?.updated_sam ?? sectionItem?.sam
            : "",
        updated_smv_ir:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "iron"
            ? sectionItem?.updated_sam ?? sectionItem?.sam
            : "",
        mc_type: sectionItem?.ob_machine_type_info?.name,
        tgt_mc:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "helper" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "ir" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "hp" &&
          sectionItem?.ob_machine_type_info?.name.toLowerCase() !== "iron"
            ? Number(
                (60 / (sectionItem?.updated_sam || sectionItem?.sam)).toFixed(
                  2,
                ),
              )
            : "",
        tgt_hp:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "helper" ||
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "hp"
            ? Number(
                (60 / (sectionItem?.updated_sam || sectionItem?.sam)).toFixed(
                  2,
                ),
              )
            : "",
        tgt_ir:
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "iron" ||
          sectionItem?.ob_machine_type_info?.name.toLowerCase() === "ir"
            ? Number(
                (60 / (sectionItem?.updated_sam || sectionItem?.sam)).toFixed(
                  2,
                ),
              )
            : "",
        workers_mc: sectionItem?.worker_machine_sam
          ? Number(sectionItem?.worker_machine_sam).toFixed(2)
          : "",
        workers_hp: sectionItem?.worker_helper_sam
          ? Number(sectionItem?.worker_helper_sam).toFixed(2)
          : "",
        workers_ir: sectionItem?.worker_iron_sam
          ? Number(sectionItem?.worker_iron_sam).toFixed(2)
          : "",
      };
    });
  });

  const newSections = [];

  for (let i = 0; i < formateSection.length; i++) {
    newSections.push({
      id: "No",
      className: "new-section",
      section_name: sections[i].section_name,
      condition: "Condition",
      smv_mc: "MC",
      smv_hp: "HP",
      smv_ir: "IR",
      updated_smv_mc: "MC",
      updated_smv_hp: "HP",
      updated_smv_ir: "IR",
      mc_type: "Type",
      tgt_mc: "MC",
      tgt_hp: "HP",
      tgt_ir: "IR",
      workers_mc: "MC",
      workers_hp: "HP",
      workers_ir: "IR",
      color: "Color",
    });
    for (let j = 0; j < formateSection[i].length; j++) {
      newSections.push(formateSection[i][j]);
    }
  }

  const columns = [
    {
      title: "OP",
      children: [
        {
          title: "No",
          dataIndex: "id",
          key: "id",
        },
      ],
    },
    {
      title: "Operation",
      children: [
        {
          title: "Name",
          dataIndex: "section_name",
          key: "section_name",
          width: "10%",
        },
        {
          title: "Condition",
          dataIndex: "condition",
          key: "condition",
          width: "10%",
        },
      ],
    },
    {
      title: "SMV",
      children: [
        {
          title: "M/C",
          dataIndex: "smv_mc",
          key: "smv_mc",
        },
        {
          title: "HP",
          dataIndex: "smv_hp",
          key: "smv_hp",
        },
        {
          title: "IR",
          dataIndex: "smv_ir",
          key: "smv_ir",
        },
      ],
    },
    {
      title: "Updated SAM",
      children: [
        {
          title: "M/C",
          dataIndex: "updated_smv_mc",
          key: "updated_smv_mc",
        },
        {
          title: "HP",
          dataIndex: "updated_smv_hp",
          key: "updated_smv_hp",
        },
        {
          title: "IR",
          dataIndex: "updated_smv_ir",
          key: "updated_smv_ir",
        },
      ],
    },
    {
      title: "M/C",
      children: [
        {
          title: "Type",
          dataIndex: "mc_type",
          key: "mc_type",
        },
      ],
    },
    {
      title: "TGT",
      children: [
        {
          title: "M/C",
          dataIndex: "tgt_mc",
          key: "tgt_mc",
        },
        {
          title: "HP",
          dataIndex: "tgt_hp",
          key: "tgt_hp",
        },
        {
          title: "IR",
          dataIndex: "tgt_ir",
          key: "tgt_ir",
        },
      ],
    },
    {
      title: "Workers",
      children: [
        {
          title: "M/C",
          dataIndex: "workers_mc",
          key: "workers_mc",
        },
        {
          title: "HP",
          dataIndex: "workers_hp",
          key: "workers_hp",
        },
        {
          title: "IR",
          dataIndex: "workers_ir",
          key: "workers_ir",
        },
      ],
    },
    {
      title: "Color",
      children: [
        {
          title: "Color",
          dataIndex: "color",
          key: "color",
        },
      ],
    },
  ];

  return (
    <InventoryLayOutCommon>
      <AppPageHeader
        extra={extra}
        title={
          <Title level={5}>
            {`Operation Bulletin ${
              view ? "Show" : ob_id && !view ? "Edit" : "Entry"
            }`}
          </Title>
        }
      />
      <Card>
        <Typography.Text strong style={headerStyle}>
          CONCORDE GARMENTS LTD
        </Typography.Text>
        <Typography.Text strong style={headerStyle}>
          IE Department
        </Typography.Text>
        <Typography.Text strong style={headerStyle}>
          Operation Bulletin
        </Typography.Text>

        <Row gutter={24} justify={"space-between"}>
          <Col>
            <strong>Buying Office: </strong>
            {obShowData?.buying_office?.name}
            <br />
            <strong>Buyer: </strong>
            {obShowData?.buyer?.name}
            <br />
            <strong>Style: </strong>
            {obShowData?.style?.style_no}
            <br />
          </Col>

          <Col>
            <strong>OB Version: </strong>
            1
            <br />
            <strong>Date: </strong>
            {cglFormatDate(obShowData?.entry_date)}
            <br />
            <strong>Description: </strong>
            {obShowData?.style?.description}
            <br />
          </Col>
        </Row>

        <Row gutter={24} justify={"space-between"}>
          <Col span={24}>
            <ListTable
              className="operation-bulletin-table"
              dataSource={newSections}
              bordered
              pagination={false}
              columns={columns}
              size="small"
              sticky
              tableLayout="fixed"
              scroll={{ y: 450 }}
              rowHoverable={false}
              onRow={(record, rowIndex) => {
                return {
                  className:
                    record?.className === "new-section" ? "new-section" : "",
                  style: {
                    background:
                      record?.className === "new-section" && "#CAF4CC",
                    color: record?.className === "new-section" && "#000000",
                    fontWeight: record?.className === "new-section" && "bold",
                  },
                };
              }}
              loading={isSectionLoading}
              error={sectionFetchError}
              onRetry={() => {
                if ((ob_id || ob_id === 0) && manpowerMode) {
                  getSelectedObInfo(ob_id, null, null, true);
                } else if (ob_id || ob_id === 0) {
                  getSelectedObInfo(ob_id);
                }
              }}
              emptyText="No records to show yet."
              summary={(pageData) => {
                if (pageData.length === 0) {
                  return null;
                }
                // total smv mc, hp, ir
                // total updated smv mc, hp, ir
                // total worker mc, hp, ir
                let totalSMVMC = 0;
                let totalSMVHP = 0;
                let totalSMVIR = 0;
                let totalUpdatedSMVMC = 0;
                let totalUpdatedSMVHP = 0;
                let totalUpdatedSMVIR = 0;
                let totalWorkerMC = 0;
                let totalWorkerHP = 0;
                let totalWorkerIR = 0;

                pageData.forEach((item) => {
                  // check nan
                  if (item?.id === "No") return;
                  if (item?.smv_mc) {
                    totalSMVMC += parseFloat(item?.smv_mc);
                  }
                  if (item?.smv_hp) {
                    totalSMVHP += parseFloat(item?.smv_hp);
                  }
                  if (item?.smv_ir) {
                    totalSMVIR += parseFloat(item?.smv_ir);
                  }
                  if (item?.updated_smv_mc) {
                    totalUpdatedSMVMC += parseFloat(item?.updated_smv_mc);
                  }
                  if (item?.updated_smv_hp) {
                    totalUpdatedSMVHP += parseFloat(item?.updated_smv_hp);
                  }
                  if (item?.updated_smv_ir) {
                    totalUpdatedSMVIR += parseFloat(item?.updated_smv_ir);
                  }
                  if (item?.workers_mc) {
                    totalWorkerMC += parseFloat(item?.workers_mc);
                  }
                  if (item?.workers_hp) {
                    totalWorkerHP += parseFloat(item?.workers_hp);
                  }
                  if (item?.workers_ir) {
                    totalWorkerIR += parseFloat(item?.workers_ir);
                  }
                });
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={3}>
                        <Typography.Text strong>Total</Typography.Text>
                      </Table.Summary.Cell>

                      <Table.Summary.Cell index={2}>
                        <Typography.Text strong>
                          {totalSMVMC.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3}>
                        <Typography.Text strong>
                          {totalSMVHP.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4}>
                        <Typography.Text strong>
                          {totalSMVIR.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>
                        <Typography.Text strong>
                          {totalUpdatedSMVMC.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}>
                        <Typography.Text strong>
                          {totalUpdatedSMVHP.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={7}>
                        <Typography.Text strong>
                          {totalUpdatedSMVIR.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8}>
                        <Typography.Text strong></Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={9}>
                        <Typography.Text strong></Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={10}>
                        <Typography.Text strong></Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={11}>
                        <Typography.Text strong></Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={12}>
                        <Typography.Text strong>
                          {totalWorkerMC.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={13}>
                        <Typography.Text strong>
                          {totalWorkerHP.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={14}>
                        <Typography.Text strong>
                          {totalWorkerIR.toFixed(2)}
                        </Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={15}>
                        <Typography.Text strong></Typography.Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Col>

          <Col span={24} style={{ marginBottom: 10 }}>
            <Typography.Text
              strong
              style={{
                fontSize: "12px",
                marginTop: "5px",
                padding: "5px 0px",
                backgroundColor: "#CDFFCD",
                display: "block",
                textAlign: "center",
              }}
            >
              Expected Production Breakdown
            </Typography.Text>
          </Col>

          <ExpectedBreakdown obShowData={obShowData} />

          <Summary obShowData={obShowData} />
        </Row>
      </Card>
      {/* for print */}
      <Content
        className="item-details"
        style={{
          display: "none",
        }}
      >
        {isPrint ? (
          <div className="printCustomDesign" ref={exportRef}>
            {/* only for show ob */}
            {view && obShowData && (
              <OBFormView obData={obShowData} view={view} edit={edit} />
            )}

            <Row gutter={24}>
              <Col span={view || manpowerMode || obShowData ? 20 : 24}>
                <>
                  {isArrayAndHasValue(sections) && (
                    <OBTable
                      obData={obShowData}
                      sectionData={sections}
                      removeRow={removeRow}
                      onChangeValue={onChangeValue}
                      onChangeSAMValue={onChangeSAMValue}
                      view={view}
                      edit={edit}
                      manpowerMode={manpowerMode}
                      rowPositionChange={rowPositionChange}
                      onSortTableBody={onSortTableBody}
                      onSortMainTable={onSortMainTable}
                    />
                  )}
                </>
              </Col>
            </Row>

            <Row gutter={24}>
              {view && obShowData && (
                <>
                  <Col span={12}>
                    <MachineSummary
                      machineSummary={obShowData?.machine_summary}
                    />
                  </Col>
                  <Col span={12}>
                    <TargetTable
                      obShowForm={obShowForm}
                      obShowData={obShowData}
                      manpowerMode={manpowerMode}
                    />
                  </Col>
                </>
              )}
            </Row>
          </div>
        ) : null}
      </Content>
      <Modal
        title="Increase Per Hour Target"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="link"
            type="default"
            icon={<DownloadOutlined />}
            onClick={handleSkip}
          >
            Skip
          </Button>,

          <Button
            key="submit"
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleOk}
          >
            Ok
          </Button>,
        ]}
      >
        <Input
          placeholder="Enter Per hour target"
          value={targetHour}
          onChange={(e) => setTargetHour(e.target.value)}
        />
      </Modal>
    </InventoryLayOutCommon>
  );
};

export default OperationBulletinShow;
